<div class="container" [ngClass]="{'small': small }">
  <div>
    <mat-icon [inline]="true">language</mat-icon>
    <app-select [options]="$langsOptions()" [formControl]="selectControl"></app-select>
  </div>
</div>